import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { HttpStatus } from "../../app/constants/HttpStatus";
import { router } from "../../app/services/router";
import { Button } from "./Button";
import { Result } from "./Result";
import { Spinner } from "./Spinner";

type LoaderProps = { error?: unknown; isFetching: boolean };

export const Loader = (props: LoaderProps) => {
  const { error, isFetching } = props;

  const { t } = useTranslation();

  if (isFetching) {
    return <Spinner />;
  }

  if (error) {
    const status =
      (error as { status: HttpStatus }).status === HttpStatus.NOT_FOUND
        ? HttpStatus.NOT_FOUND
        : HttpStatus.INTERNAL_SERVER_ERROR;
    const { action, text, title } = t("features.shared.Loader", {
      context: status,
    }) as unknown as {
      action: { text: string };
      text: string;
      title: string;
    };

    return (
      <Result
        action={
          <Button asChild variant="action">
            <Link to={router.getTo("home")}>{action.text}</Link>
          </Button>
        }
        status={status}
        text={text}
        title={title}
      />
    );
  }

  return <Spinner />;
};
